import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxUploaderModule } from 'ngx-uploader';
import { WebcamModule } from 'ngx-webcam';

import { FileManagerUploadComponent } from '../file-manager-upload/file-manager-upload.component';
import { FileManagerViewComponent } from './file-manager-view.component';
import { FileManagerImageComponent } from './file-manager-image/file-manager-image.component';
import { FileManagerContextComponent } from './file-manager-context/file-manager-context.component';
import { FileManagerImageDetailComponent } from './file-manager-image-detail/file-manager-image-detail.component';
import { FileManagerVcComponent } from './file-manager-vc/file-manager-vc.component';
import { FileCameraUploadComponent } from './file-camera-upload/file-camera-upload.component';

import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

// import { MatVideoModule } from 'mat-video';

@NgModule({
    declarations: [
        FileManagerUploadComponent,
        FileManagerViewComponent,
        FileManagerImageComponent,
        FileManagerContextComponent,
        FileCameraUploadComponent,
        FileManagerImageDetailComponent,
        FileManagerVcComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgxUploaderModule,
        DragDropModule,
        ReactiveFormsModule,
        WebcamModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatDialogModule,
        MatSnackBarModule,
        MatProgressBarModule,
        MatSliderModule,
        MatIconModule,
        MatChipsModule,
        MatAutocompleteModule,
        // MatVideoModule,
        // VgCoreModule,
        // VgControlsModule,
        // VgOverlayPlayModule,
        // VgBufferingModule,
    ],
    exports: [
        FileManagerUploadComponent,
        FileManagerViewComponent,
        FileManagerImageComponent,
        FileManagerContextComponent,
        FileManagerImageDetailComponent,
    ]
})
export class FileManagerViewModule { }
